import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './action'
import mutations from './mutations'
Vue.use(Vuex)

const state = {
  botinfo: [],
  replyinfo: [],
  editmsgreplyinfo: [],
  friendinfo: [],
  groupinfo: [],
  myprofile: '',
  showmember: {},
  myname: '',
  groupmember: [],
  layout: '',
  sendrequest: [],
  listsendrequest: [],
  request: [],
  listrequest: [],
  listfriend: [],
  listchat: [],
  groupreq: [],
  listgroupreq: [],
  listgroup: [],
  tokenroom: '',
  groupidremove: '',
  chatfile: '',
  chatimage: ''
}

export default new Vuex.Store({
  state,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js